import { BrowserRouter, Route, Routes } from "react-router-dom"
import useRoutes from "../hooks/useRoutes"
import { useCopies } from "../contexts/CopiesContext"
import { useEffect } from "react"
import { track } from "../utils/track"
import { setCookie } from "../utils/cookies"
import { useSettings } from "../contexts/SettingsContext"
import clsx from "clsx"

const Router = () => {
  const routes = useRoutes()
  const { setToken } = useSettings()
  const { language } = useCopies()

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search)
    const token = urlParams.get("token")

    if (token) {
      setCookie("token", token)
      setToken(token)
      // Remove token from the URL after loading it
      const url = new URL(window.location.href)
      url.searchParams.delete("token")
      const newUrl = `${url.pathname}${url.search ? `?${url.searchParams.toString()}` : ""}${url.hash}`
      window.history.replaceState({}, "", newUrl)
    }

    track("Loaded", { platform: "web" })
  }, [setToken])

  const path = window.location.pathname
  return (
    <main className={clsx(language === "he" ? "rtl" : "lrt", { root: !path.includes("/join/") && !path.includes("/student/edit") && !path.includes("/student/note") })}>
      <BrowserRouter>
        <Routes>
          {routes.map((route) => (
            <Route path={route.path} element={route.element} key={route.id} />
          ))}
        </Routes>
      </BrowserRouter>
    </main>
  )
}

export default Router
